import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // The submit button names the action it performs, so its label differs per modal. Remember
  // whatever it was rendered with: asking for signatures renames it, and clearing the box has
  // to put the original name back.
  connect() {
    this.defaultText = this.labelOf(this.submitButton())
  }

  toggle({ target }) {
    const button = this.submitButton()
    if (!button) return

    const text = target.checked ? 'Lock all and request signatures' : this.defaultText

    button.value = text
    const content = button.querySelector('.button__content')
    if (content) content.textContent = text
  }

  submitButton() {
    const frame = this.element.closest('turbo-frame')
    return frame?.querySelector('[data-reporting-cycles--confirm-bulk-lock-target="submitButton"]')
  }

  labelOf(button) {
    if (!button) return ''

    const content = button.querySelector('.button__content')
    return (content ? content.textContent : button.value).trim()
  }
}
